export abstract class TagModel {
  event: string;
  calculationID: string;
  partnerID: string;
  userID: string;
}
